import C from './constants'

export const setUnitConverterValues = (values) => (
    {
        type: C.SET_UNIT_CONVERTER_VALUES,
        payload: values
    }
)
